import React from "react";

/**
 * Clears the line of all previous floating elements.
 * @constructor
 */
function ClearLine() {
    return (<div style={{"clear": "both"}}/>);
}

export default ClearLine;